import React from 'react';

const LayoutTopPageBottom = ({ children }) => {
  return <>{children}</>;
};

export default LayoutTopPageBottom;
